export class Step2 {
    constructor() {}

    getmotclef = 'form.dive_an.getmotclef_liste_avi_';
    getcp = 'form.dive_an.getcp';
    getville = 'form.dive_an.getville';
    getnum = 'form.dive_an.getnum';
    gettypevoie = 'form.dive_an.gettypevoie';
    getnomvoie = 'form.dive_an.getnomvoie';
    getobjet = 'form.dive_an.getobjet';
    gettravaux = 'form.dive_an.gettravaux';
    getexecution = 'form.dive_an.getexecution';
    getfournitures = 'form.dive_an.getfournitures';
    getservices = 'form.dive_an.getservices';
    getspan4 = 'form.dive_an.getspan4';
    getlieuexecutionlivraison = 'form.dive_an.getlieuexecutionlivraison';
    getspan2 = 'form.dive_an.getspan2';
    getspan21 = 'form.dive_an.getspan21';
    getspan22 = 'form.dive_an.getspan22';
    getspan23 = 'form.dive_an.getspan23';
    ajouter = 'form.dive_an.ajouter';
    supprimer = 'form.dive_an.supprimer';
    getclassprincipale = 'form.dive_an.getclassprincipale';
    getclasssupplementaire = 'form.dive_an.getclasssupplementaire';
    getprocedure = 'form.dive_an.getprocedure';
    getspan5 = 'form.dive_an.getspan5';
}
